import logo from './logo.svg';
import './App.css';
import './style-sitcher.css'
/* import './color-1.css' */
import "./Chargement.css"
import AOS from 'aos';
import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faDownload } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faWhatsapp, faInstagram, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import defaultImage from './ImageProjet/medium-shot-anime-style-man-portrait.jpg'
import projet1 from './ImageProjet/isometric-shopping-online-landing-page-template_23-2148541210.avif'
import projet2 from './ImageProjet/leagueMionkan.png'
import projet3 from './ImageProjet/elearning.png'
import projet4 from './ImageProjet/leagueMionkan.png'
import projet5 from './ImageProjet/techblog.png'
import projet6 from './ImageProjet/8356139_3890438.jpg'
import meee from './ImageProjet/maphoto1.jpeg'
import { useState } from 'react';
import Typewriter from './typing';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';



function App() {

  const [currentTheme, setCurrentTheme] = useState('color-4'); // Default theme

  useEffect(() => {
    // Charger dynamiquement le fichier CSS en fonction du thème sélectionné
    import(`./${currentTheme}.css`).then(() => {
      console.log(`Thème ${currentTheme} chargé avec succès.`);
    }).catch((err) => {
      console.error(`Erreur lors du chargement du thème ${currentTheme}`, err);
    });
  }, [currentTheme]);

  const setActiveStyle = (color) => {
    const existingLink = document.querySelector(`link[data-theme="${color}"]`);

    if (existingLink) {
      // Retirer l'ancien fichier CSS
      document.head.removeChild(existingLink);
    }

    // Ajouter un nouveau lien pour forcer le rechargement
    const linkElement = document.createElement('link');
    linkElement.rel = 'stylesheet';
    linkElement.href = `/${color}.css`; // Charger depuis le dossier public
    linkElement.setAttribute('data-theme', color);
    document.head.appendChild(linkElement);

    setCurrentTheme(color);
  };


  const toggleStyleSwitcher = () => {
    document.querySelector('.style-switcher').classList.toggle('open');
  };

  const toggleDayNightMode = () => {
    document.body.classList.toggle('dark');
    const icon = document.querySelector('.day-night i');
    icon.classList.toggle('fa-sun');
    icon.classList.toggle('fa-moon');
  };

  useEffect(() => {
    const icon = document.querySelector('.day-night i');
    if (document.body.classList.contains('dark')) {
      icon.classList.add('fa-sun');
    } else {
      icon.classList.add('fa-moon');
    }
  }, []);

  useEffect(() => {
    const nav = document.querySelector(".nav"),
      navList = nav.querySelectorAll("li"),
      totalNavList = navList.length;
    for (let i = 0; i < totalNavList; i++) {
      const a = navList[i].querySelector("a");
      a.addEventListener("click", function () {
        for (let j = 0; j < totalNavList; j++) {
          navList[j].querySelector("a").classList.remove("active")
        }
        this.classList.add("active")

      })
    }

  })

  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const styleSwitcher = document.querySelector('.style-switcher');
      if (styleSwitcher && styleSwitcher.classList.contains('open')) {
        styleSwitcher.classList.remove('open');
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const texts = [
    "Je suis un développeur Web",
    "Je fais également du mobile."
  ];

  const [age, setAge] = useState(0);

  useEffect(() => {
    const calculateAge = (birthDate) => {
      const today = new Date();
      const birthDateObj = new Date(birthDate);
      let age = today.getFullYear() - birthDateObj.getFullYear();
      const monthDifference = today.getMonth() - birthDateObj.getMonth();

      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDateObj.getDate())) {
        age--;
      }

      return age;
    };

    // Remplace cette date par ta date de naissance
    const birthDate = "2003-08-13";
    setAge(calculateAge(birthDate));
  }, []);

  const handleView = (url) => {
    const fullUrl = `${process.env.PUBLIC_URL}${url}`;
    window.open(fullUrl, '_blank');
  }

  const handleDownload = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    const urlObject = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = urlObject;
    a.download = url.substring(url.lastIndexOf('/') + 1);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const [donnes, setDonnes] = useState({})

  const handleChange = (name, value) => {
    setDonnes((prev) => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    setIsLoading(true)

    try {
      const response = await axios.post("https://backportfolio-flame.vercel.app/receivemail", donnes)
      if (response.status == 200) {
        console.log("Email envoyer avec succès")
        toast.success("Email envoyer avec succès")
      } else if (response.status == 202) {
        console.log("Vérifier votre connexion internet")
        toast.error("Email non envoyer ! Vérifier votre connexion internet et réssayer")
      }
    } catch (error) {
      toast.error("Erreur lors de l'envoie du mail")
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const [isloading, setIsLoading] = useState(false)

  return (<>
    {/* ===== Main Container Start ===== */}
    <div className="main-container">
      <ToastContainer
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {/* ==== Aside Start ==== */}
      


      <div className='aside'>
      
        <div className='logo'>
          <a href="#" data-aos="zoom-in" data-aos-duration="5000" data-aos-easing="ease-in-out"> <span>@</span>TCHN</a>
        </div>
        <div className='nav-toggler'>
          <span></span>
        </div>
        <ul className="nav">
          <li data-aos="fade-right" data-aos-delay="500" data-aos-duration="2000"><a className='active' href="#home"><i className='fa fa-home' data-aos="fade-right" data-aos-delay="500" data-aos-duration="2000"></i> Accueil</a></li>
          <li data-aos="fade-right" data-aos-delay="1000" data-aos-duration="2000"><a href="#about"><i className='fa fa-user' data-aos="fade-right" data-aos-delay="500" data-aos-duration="2000"></i> A propos</a></li>
          <li data-aos="fade-right" data-aos-delay="1500" data-aos-duration="2000"><a href="#services"><i className='fa fa-list' data-aos="fade-right" data-aos-delay="500" data-aos-duration="2000"></i> Services</a></li>
          <li data-aos="fade-right" data-aos-delay="2000" data-aos-duration="2000"><a href="#portfolio"><i className='fa fa-briefcase' data-aos="fade-right" data-aos-delay="500" data-aos-duration="2000"></i> Portfolio</a></li>
          <li data-aos="fade-right" data-aos-delay="2500" data-aos-duration="2000"><a href="#contact"><i className='fa fa-comments' data-aos="fade-right" data-aos-delay="500" data-aos-duration="2000"></i> Contacts</a></li>
        </ul>
      </div>
      {/* ==== Aside End ==== */}


      {/* ==== Main Content Start ==== */}
      <div className='main-content'>
     
        {/* ==== Home Section Start ==== */}
        <section className='home active section ' id='home'>
        
          <div className="container">
            <div class="image-container">
      <center>
        <span className="bienvenue" data-aos="zoom-in" data-aos-duration="5000" data-aos-easing="ease-in-out">
          🎉 Bienvenue dans mon univers créatif ! Découvrez mes projets et mon expertise.
        </span>
      </center>
              <img src={meee} data-aos="fade-up" data-aos-duration="5000" data-aos-easing="ease-in-out" alt="Description de l'image" style={{ width: "100%", height: "100%", borderRadius: "5px" }} />

            </div>
            <div className="row">
              <div className="home-info padd-15">

                <h3 className="hello" data-aos="fade-down" data-aos-easing="linear" data-aos-duration="800" data-aos-delay="50" style={{ whiteSpace: "normal", overflow: "visible", textOverflow: "unset", display: "block", maxHeight: "none", wordBreak: "break-word" }}>Salut 👋️, c'est <span className='name'>M. Aurel TCHANHOUIN</span></h3>
                <h3 className='my-profession' data-aos="fade-right" data-aos-delay="1000">Plaisir de vous voir sur mon portfolio 😊️.<Typewriter texts={texts} speed={80} deleteSpeed={50} delay={800} /></h3>
                {/* <p>I'm a web Designer extensive experience for  over 3years. My expertise is to create and website desin, graphic, and many more...
                </p> */}
                <p data-aos="fade-up" data-aos-easing="ease-in-out" style={{ fontSize: '16px' }} data-aos-delay="1500" >
                  Passionné par la technologie et l'innovation, je suis un analyste informatique et développeur spécialisé dans la création de solutions web et mobiles performantes, intuitives et adaptées aux besoins des utilisateurs. Fort de plusieurs années d'expérience, j'interviens aussi en tant que freelance pour accompagner entreprises et particuliers dans la concrétisation de leurs projets numériques.
                </p>
                <a href="#contact" data-aos="fade-down" data-aos-delay="1000" className='btn hire-me'>Saluez-moi</a>
              </div>
              <div className="home-img padd-15" data-aos-easing="ease-in-out" data-aos-duration="2000">
                <img src={meee} alt="" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="50" />
              </div>
            </div>
          </div>
        </section>
        {/* ==== Home Section End ==== */}


        {/* ==== About Section Start ==== */}
        <section className='about section gggg' id='about'>
          <div className="container">
            <div className="row">
              <div className="section-title padd-15">
                <h2>A propos</h2>
              </div>
            </div>
            <div className="row">
              <div className="about-content padd-15">
                <div className="row">
                  <div className="about-text padd-15">
                    <h3>Je suis un <span>Dévelopeur Web et Mobile</span></h3>
                    <p data-aos="fade-right">  Je m'appelle <strong>Aurel TCHANHOUIN</strong>, analyste informatique et programmeur passionné
                      par la création de solutions numériques innovantes et performantes.Avec un solide parcours
                      académique en informatique et plusieurs
                      mois d'expérience dans le développement <strong>web</strong>  et <strong>mobile</strong> , j'ai acquis une expertise approfondie
                      en analyse de systèmes, en développement front-end, notamment avec <strong> React JS</strong>, développement back-end, notamment en <strong>Node JS</strong>, Laravel et en développement mobile, notamment en <strong>Flutter</strong>.

                      Mon approche se concentre sur la compréhension approfondie des besoins des utilisateurs
                      et la conception de solutions qui allient performance, esthétique, et fonctionnalité.
                      Que ce soit pour développer une application web, mobile, optimiser un processus métier, ou
                      résoudre des problématiques techniques complexes, je mets un point d'honneur à fournir
                      un travail de qualité, tout en respectant les délais et les exigences du projet.

                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="personal-info padd-15">
                    <div className="row">
                      <div className="info-item padd-15">
                        <p > Date de naissance :<span data-aos="fade-right">13 Août 2003</span></p>
                      </div>
                      <div className="info-item padd-15">
                        <p >Age : <span data-aos="fade-right">{age} ans</span></p>
                      </div>
                      <div className="info-item padd-15">
                        <p >Website : <span data-aos="fade-right"><a href="https://finish-front-elearning.vercel.app/" className='lienn' target='_blanck' >Elearning</a></span></p>
                      </div>
                      <div className="info-item padd-15" >
                        <p>Langues : <span data-aos="fade-right">Français Anglais</span></p>
                      </div>
                      <div className="info-item padd-15">
                        <p>Diplôme : <span data-aos="fade-right">Bientôt la licence</span></p>
                      </div>
                      <div className="info-item padd-15">
                        <p >Téléphone : <span data-aos="fade-right">+229 0165625955</span></p>
                      </div>
                      <div className="info-item padd-15">
                        <p >Ville : <span data-aos="fade-right"> Cotonou Bénin</span></p>
                      </div>
                      <div className="info-item padd-15">
                        <p>Freelancer : <span data-aos="fade-right"> Disponible</span></p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="buttons padd-15">
                        <div className='btn' onClick={() => handleView('/mon_CV(1)-1.pdf')} style={{ cursor: 'pointer' }}>
                          <FontAwesomeIcon icon={faEye} style={{ marginRight: "8px" }} />
                          Voir le CV</div>
                        <div className='btn hire-me' onClick={() => handleDownload('/mon_CV(1)-1.pdf')} style={{ cursor: 'pointer' }}>
                          <FontAwesomeIcon icon={faDownload} style={{ marginRight: "8px" }} />
                          Télécharger le CV</div>
                      </div>
                    </div>
                  </div>
                  <div className='skills padd-15'>
                    <div className="row">

                      <div className="skill-item padd-15" data-aos="fade-up">
                        <h5>Laravel</h5>
                        <div className="progress">
                          <div className="progress-in" style={{ width: "84%" }}></div>
                          <div className="skill-percent">83%</div>
                        </div>
                      </div>
                      <div className="skill-item padd-15" data-aos="fade-up">
                        <h5>Node JS</h5>
                        <div className="progress">
                          <div className="progress-in" style={{ width: "86%" }}></div>
                          <div className="skill-percent">86%</div>
                        </div>
                      </div>
                      <div className="skill-item padd-15" data-aos="fade-up">
                        <h5>Flutter</h5>
                        <div className="progress">
                          <div className="progress-in" style={{ width: "83%" }}></div>
                          <div className="skill-percent">84%</div>
                        </div>
                      </div>
                      <div className="skill-item padd-15" data-aos="fade-up">
                        <h5>React JS</h5>
                        <div className="progress">
                          <div className="progress-in" style={{ width: "80%" }}></div>
                          <div className="skill-percent">80%</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="education padd-15">
                    <h3 className='title' >Educations</h3>
                    <div className="row">
                      <div className="timeline-box padd-15">
                        <div className="timeline shadow-dark">
                          {/*  ===== Timeline item ====== */}
                          <div className="timeline-item">
                            <div className="circle-dot" data-aos="zoom-in-right"></div>
                            <h3 className="timeline-date" data-aos="zoom-in-right">
                              <i className='fa fa-calendar' data-aos="zoom-in-right"></i> 2022-2025
                            </h3>
                            <h4 className='timeline-title' data-aos="zoom-in-right">Licence en Informatique</h4>
                            <p className='timeline-text' data-aos="zoom-in-right">Université d'Abomey Calivi, <b>E</b>cole <b>N</b>ationale d'<b>E</b>conomie <b>A</b>ppliquée et de <b>M</b>anagement <b>(ENEAM)</b>; Cotonou, Bénin <br />
                              Cours suivis : Développement Web (Front-End et Back-End), Bases de données, Algorithmique, Gestion de projets informatiques.
                              Spécialisation en développement web et mobile. Réalisation de projets tels que le
                              développement d'une application de gestion d'apprentissage des élèves et la création d'un système de
                              recommandation basé sur l'apprentissage automatique. Membre actif du club de programmation
                              SMOOD.
                            </p>
                          </div>

                          {/*  ===== Timeline item ====== */}
                          <div className="timeline-item" >
                            <div className="circle-dot" data-aos="fade-right"></div>
                            <h3 className="timeline-date" data-aos="fade-right">
                              <i className='fa fa-calendar' data-aos="fade-right"></i> Août 2022
                            </h3>
                            <h4 className='timeline-title' data-aos="fade-right">Formation en Initialisation à l'Informatique</h4>
                            <p className='timeline-text' data-aos="fade-right">Une formation technique axée sur l'apprentissage des logiciels informatiques, au cours de laquelle nous avons approfondi l'utilisation de logiciels essentiels tels que Word, Excel, PowerPoint et Publisher. J'ai eu l'honneur d'être élu responsable de classe durant cette formation.
                              <br />
                              Mention sur l'attestation : <strong> Très Bien</strong>

                            </p>
                          </div>

                          {/*  ===== Timeline item ====== */}
                          <div className="timeline-item" >
                            <div className="circle-dot" data-aos="fade-right"></div>
                            <h3 className="timeline-date" data-aos="fade-right">
                              <i className='fa fa-calendar' data-aos="fade-right"></i> 2021-2022
                            </h3>
                            <h4 className='timeline-title' data-aos="fade-right">Baccalauréats Scientifiques (Série C & D)</h4>
                            <p className='timeline-text' data-aos="fade-right">J'ai obtenu mon Baccalauréat série C en 2021 au Collège d'Enseignement Général de Godomey. En 2022, j'ai poursuivi mes études en obtenant le Baccalauréat série D au Complexe Scolaire LES PYRAMIDES Agla, au Bénin. <br />

                              Mention : <strong> Bien</strong>

                            </p>
                          </div>



                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="experience padd-15"/*  data-aos="fade-right" */>
                    <h3 className='title' >Expériences</h3>
                    <div className="row">
                      <div className="timeline-box padd-15">
                        <div className="timeline shadow-dark">
                          {/*  ===== Timeline item ====== */}
                          <div className="timeline-item" >
                            <div className="circle-dot" data-aos="zoom-in-right"></div>
                            <h3 className="timeline-date" data-aos="zoom-in-right">
                              <i className='fa fa-calendar' data-aos="zoom-in-right"></i> 2022-2023
                            </h3>
                            <h4 className='timeline-title' data-aos="zoom-in-right">Développeur Full-Stack</h4>
                            <p className='timeline-text' data-aos="zoom-in-right">Conception et développement d'applications web
                              complètes en utilisant React.js
                              pour le Frontend et Node.js/Express pour le Backend.
                              Intégration de
                              bases de données (MySQL, Oracle) et API pour des fonctionnalités dynamiques.
                              <br /> <a href="https://finish-front-elearning.vercel.app/" target='_blank' className='lienn'>Voir le site</a>
                            </p>
                          </div>

                          {/*  ===== Timeline item ====== */}
                          <div className="timeline-item" >
                            <div className="circle-dot" data-aos="fade-right"></div>
                            <h3 className="timeline-date" data-aos="fade-right">
                              <i className='fa fa-calendar' data-aos="fade-right"></i> 2024
                            </h3>
                            <h4 className='timeline-title' data-aos="fade-right">Stagiaire Développeur Web | Entreprise INAWO</h4>
                            <p className='timeline-text' data-aos="fade-right">06 Mai 2024 - 20 septembre 2024 <br />
                              Participation au développement d'une application web de gestion de commerce avec React.js.
                              Implémentation de fonctionnalités back-end en respectant les bonnes pratiques de développement.
                              Collaboration avec l'équipe pour résoudre les bugs et améliorer l'expérience utilisateur.
                              Utilisation de Git pour la gestion de versions et la collaboration en équipe.
                            </p>
                          </div>

                          {/*  ===== Timeline item ====== */}

                          {/*  ===== Timeline item ====== */}
                          <div className="timeline-item" >
                            <div className="circle-dot" data-aos="fade-right"></div>
                            <h3 className="timeline-date" data-aos="fade-right">
                              <i className='fa fa-calendar' data-aos="fade-right"></i> 2025
                            </h3>
                            <h4 className='timeline-title' data-aos="fade-right">Développement d'une application Mobile | Techblog</h4>
                            <p className='timeline-text' data-aos="fade-right">25 Décembre 2024 - 10 février 2025 <br />
                              Conception d'une application mobile intuitive dédiée à un blog informatique. Cette application permet aux utilisateurs de découvrir plusieurs articles sur l'informatique et d'interagir avec eux en likant, commentant, partageant et ajoutant en favoris pour une relecture ultérieure.
                              <br />
                              <a href="https://techblog.infinityfreeapp.com" target='_blank' className='lienn'>Visitez le guide d'installation de cette application</a>
                            </p>
                          </div>

                          {/*  ===== Timeline item ====== */}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ==== About Section End ==== */}

        {/* ==== Service Section Start ==== */}
        <section className='service section' id='services'>
          <div className="container">
            <div className="row">
              <div className="section-title padd-15">
                <h2>Services</h2>
              </div>
            </div>
            <div className="row">
              {/* === Service item Start ==== */}
              <div className="service-item padd-15" >
                <div className="service-item-inner">
                  <div className="icon" data-aos="zoom-in">
                    <div className="fa fa-laptop-code"></div>
                  </div>
                  <h4 data-aos="fade-right">Développement Web Front-End</h4>
                  <p data-aos="fade-right">Création d'interfaces utilisateur modernes et réactives avec React.js, HTML5, CSS3, et JavaScript.</p>
                </div>
              </div>
              {/* === Service item End ==== */}
              {/* === Service item Start ==== */}
              <div className="service-item padd-15">
                <div className="service-item-inner">
                  <div className="icon" data-aos="zoom-in">
                    <div className="fa fa-palette"></div>
                  </div>
                  <h4 data-aos="fade-down">Développement Web Back-End</h4>
                  <p data-aos="fade-down">Conception et développement de serveurs robustes avec Laravel, Node.js et Express.
                    Gestion des bases de données relationnelles (MySQL).
                  </p>
                </div>
              </div>
              {/* === Service item End ==== */}
              {/* === Service item Start ==== */}
              <div className="service-item padd-15" >
                <div className="service-item-inner">
                  <div className="icon" data-aos="zoom-in">
                    <div className="fa fa-mobile-alt"></div>
                  </div>
                  <h4 data-aos="fade-right">Développement Mobile sur Mesure</h4>
                  <p data-aos="fade-right">
                    Conception et développement d’applications mobiles performantes et ergonomiques avec Flutter, adaptées aux besoins des entreprises et startups.
                  </p>
                </div>
              </div>
              {/* === Service item End ==== */}



            </div>
          </div>
        </section>
        {/* ==== Service Section End ==== */}

        {/* ==== Portfolio Section Start ==== */}
        <section className='portfolio section' id='portfolio'>
          <div className="container">
            <div className="row">
              <div className="section-title padd-15">
                <h2>Portfolio</h2>
              </div>
            </div>
            <div className="row">
              <div className="portfolio-heading padd-15">
                <h2 style={{ fontFamily: "arial" }}>Mes projets:</h2>
              </div>
            </div>
            <div className="row">
              {/* ------ portfolio item start--------- */}

              <div className="portfolio-item padd-15" data-aos="flip-right">
                <a href='https://techblog.infinityfreeapp.com/' target='_blank' className='lienn'>
                  <div className="portfolio-item-inner shadow-dark">
                    <div className="portfolio-img">
                      <img src={projet5} style={{ width: "100%", height: "100%" }} alt="" />
                      <strong> Visitez le guide d'installation</strong>
                    </div>
                  </div>
                </a>
              </div>

              {/* ------ portfolio item end--------- */}
              {/* ------ portfolio item start--------- */}
              <div className="portfolio-item padd-15" data-aos="zoom-in">
                <a href='https://mionkanleague.infinityfreeapp.com/' target='_blank' className='lienn'>
                  <div className="portfolio-item-inner shadow-dark">
                    <div className="portfolio-img">
                      <img src={projet2} alt="" style={{ width: "100%", height: "50%" }} />
                      <strong> Visitez la leagueMionkan</strong>
                    </div>
                  </div>
                </a>
              </div>
              {/* ------ portfolio item end--------- */}
              {/* ------ portfolio item start--------- */}
              <div className="portfolio-item padd-15" data-aos="fade-up">
                <a href='https://finish-front-elearning.vercel.app/' target='_blank' className='lienn'>
                  <div className="portfolio-item-inner shadow-dark">
                    <div className="portfolio-img">
                      <img src={projet3} alt="" style={{ width: "100%", height: "50%" }} />
                      <strong> Visitez Elearning</strong>
                    </div>
                  </div>
                </a>
              </div>
              {/* ------ portfolio item end--------- */}

              {/* ------ portfolio item end--------- */}
            </div>
          </div>
        </section>
        {/* ==== Portfolio Section End ==== */}

        {/* ==== Contact Section Start ==== */}
        <div className="section contact" id='contact'>
          <div className="container">
            <div className="row">
              <div className="section-title padd-15">
                <h2>Contactez-moi</h2>
              </div>
            </div>
            <h3 className='contact-title padd-15' data-aos="fade-up">Avez-vous de questions ?</h3>
            <h4 className="contact-sub-title padd-15" data-aos="fade-up">JE SUIS A VOS SERVICES</h4>
            <div className="row">
              {/* ==== Contact info item start ====== */}
              <div className="contact-info-item padd-15" >
                <a href="tel:+22965625955">
                  <div className="icon"><i className="fa fa-phone" data-aos="fade-down"></i></div>
                  <h4 data-aos="fade-down">Appel-moi sur</h4>
                  <p data-aos="fade-down">
                    +229 01 65 62 59 55
                  </p>
                </a>
              </div>
              {/* ==== Contact info item end ====== */}
              {/* ==== Contact info item start ===== */}
              <div className="contact-info-item padd-15">
                <a
                  href="https://www.google.com/maps?q=Cocotomey"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="icon"><i className="fa fa-map-marker-alt" data-aos="fade-right"></i></div>
                  <h4 data-aos="fade-right">Localité</h4>
                  <p data-aos="fade-right">
                    Cocotomey
                  </p>
                </a>
              </div>
              {/* ==== Contact info item end === */}
              {/* ==== Contact info item start ==== */}
              <div className="contact-info-item padd-15">
                <a href="mailto:aureltchanhouin@gmail.com">
                  <div className="icon"><i className="fa fa-envelope" data-aos="fade-down"></i></div>
                  <h4 data-aos="fade-down">Email</h4>
                  <p data-aos="fade-down">
                    aureltchanhouin@gmail.com
                  </p>
                </a>
              </div>
              {/* ==== Contact info item end === */}
              {/* ==== Contact info item start ==== */}
              <div className="contact-info-item padd-15" >
                <a href="https://mionkanleague.infinityfreeapp.com/" target="_blank">
                  <div className="icon"><i className="fa fa-globe-europe" data-aos="fade-up"></i></div>
                  <h4 data-aos="fade-up">Website</h4>
                  <p data-aos="fade-up">seniormood.free.nf</p>
                </a>
              </div>
              {/* ==== Contact info item end === */}
            </div>
            <h3 className='contact-title padd-15' data-aos="fade-up">ENVOYEZ-MOI UN EMAIL</h3>
            <h4 className="contact-sub-title padd-15" data-aos="fade-up">JE SUIS TRÈS RÉACTIF AUX MESSAGES</h4>
            {/* ====== Contact Form ======== */}
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className='contact-form padd-15'>
                  <div className="row">
                    <div className="form-item col-6 padd-15" >
                      <div className="form-group">
                        <input type="text" className='form-control' onChange={(e) => handleChange("name", e.target.value)} placeholder='Name' required />
                      </div>
                    </div>
                    <div className="form-item col-6 padd-15" >
                      <div className="form-group">
                        <input type="email" className='form-control' onChange={(e) => handleChange("email", e.target.value)} placeholder='Email' required />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-item col-12 padd-15" >
                      <div className="form-group">
                        <input type="text" className='form-control' onChange={(e) => handleChange("subject", e.target.value)} placeholder='Subject' required />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-item col-12 padd-15" >
                      <div className="form-group">
                        <textarea name="" className='form-control' id="" placeholder='Message' onChange={(e) => handleChange("message", e.target.value)} required></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-item col-12 padd-15" data-aos="fade-right">
                      <div className="form-group">
                        <button type='submit' style={{ cursor: "pointer" }} className='btn'> {isloading ? (<div>
                          <span className="spinner"></span>
                          <span> Patientez...</span>
                        </div>) : (
                          <h5 className="fw-bold">Envoyer le message</h5>
                        )}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        {/* ==== Contact Section End ==== */}
      </div>
      {/* ==== Main Content End ==== */}

    </div >
    {/* ===== Main Container End ===== */}

    {/* ===== Style Switcher Start ==== */}
    <div className="style-switcher">

      <div className="style-switcher-toggler s-icon" onClick={toggleStyleSwitcher} data-aos="fade-right" data-aos-delay="2500">
        <i className="fas fa-cog fa-spin" ></i>
      </div>
      <div className="day-night s-icon" onClick={toggleDayNightMode} data-aos="fade-right" data-aos-delay="3000">
        <i className="fas"></i>
      </div>
      <h4>Theme Colors</h4>
      <div className='colors'>
        <span className='color-1' onClick={() => setActiveStyle('color-1')}></span>
        <span className='color-2' onClick={() => setActiveStyle('color-2')}></span>
        <span className='color-3' onClick={() => setActiveStyle('color-3')}></span>
        <span className='color-4' onClick={() => setActiveStyle('color-4')}></span>
        <span className='color-5' onClick={() => setActiveStyle('color-5')}></span>
      </div>
      <div className='menu'>
        <h4 style={{ marginTop: "15px" }}>Menus</h4>
        <ul className="menu-petit">
          <li ><a className='active' href="#home"><i className='fa fa-home' ></i> Accueil</a></li>
          <li ><a href="#about"><i className='fa fa-user' ></i> A propos</a></li>
          <li ><a href="#services"><i className='fa fa-list'></i> Services</a></li>
          <li ><a href="#portfolio"><i className='fa fa-briefcase' ></i> Portfolio</a></li>
          <li ><a href="#contact"><i className='fa fa-comments'></i> Contacts</a></li>
        </ul>
      </div>
    </div>
    {/* ===== Style Switcher End ==== */}

    {/* Footer */}

    <footer style={{ backgroundColor: '#333', color: 'white', padding: '20px 0', textAlign: 'center' }}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '30px', marginBottom: '10px' }}>
        <a href="https://www.facebook.com/aurelamor.tchanhouin" target="_blank" rel="noopener noreferrer" style={{ color: '#1877F2' }}>
          <FontAwesomeIcon icon={faFacebookF} style={{ fontSize: '1.5rem' }} />
        </a>
        <a href="https://wa.me/+22945594778" target="_blank" rel="noopener noreferrer" style={{ color: '#25D366' }}>
          <FontAwesomeIcon icon={faWhatsapp} style={{ fontSize: '1.5rem' }} />
        </a>
        <a href="https://www.instagram.com/aureltchn" target="_blank" rel="noopener noreferrer" style={{ color: '#E4405F' }}>
          <FontAwesomeIcon icon={faInstagram} style={{ fontSize: '1.5rem' }} />
        </a>
        <a href="https://twitter.com/@tchan77408" target="_blank" rel="noopener noreferrer" style={{ color: '#1DA1F2' }}>
          <FontAwesomeIcon icon={faTwitter} style={{ fontSize: '1.5rem' }} />
        </a>
      </div>
      <p style={{ margin: 0 }}>&copy; 2024 &copy;. Tous droits réservés.</p>
    </footer>
  </>
  );
}

export default App;
